import userSlice from '~/redux/slices/userSlice';

function useUser() {
  const userQueryState = userSlice.endpoints.getUser.useQueryState();
  const user = userQueryState.data?.user;
  return user;
}

export default useUser;
